<template>
  <header class="invoice-form-section-header">
    <h3 v-if="this.title">{{ this.title }}</h3>
    <invoice-form-section-step-counter
      v-if="this.currentStep && this.totalSteps"
      :currentStep="this.currentStep"
      :totalSteps="this.totalSteps"
    />
  </header>
</template>

<script>
import InvoiceFormSectionStepCounter from './InvoiceFormSectionStepCounter.vue'

export default {
  name: 'InvoiceFormSectionHeader',
  components: {
    InvoiceFormSectionStepCounter
  },
  props: {
    title: {
      type: String
    },
    currentStep: {
      type: Number
    },
    totalSteps: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/Variables.scss';

.invoice-form-section-header {
  border-bottom: 1px solid $grey;
  margin-bottom: 1.875rem;
}

@media (min-width: 768px) {
  .invoice-form-section-header {
    display: flex;
    justify-content: space-between;
  }
}
</style>
